import styled from "styled-components";

export const Image = styled.img`
  max-height: 80px;
  filter: ${({ theme }) => theme.imageFilter};
`;
